import { isRunningCypressTest } from 'common/utils/context'

const postDataToPage = (url, inputs, newTab = false) => {
  const form = createForm(document, url, inputs)

  if (newTab && !isRunningCypressTest()) {
    form.setAttribute('target', '_blank')
  }

  submitForm(document, form)
}

const createForm = (parentDocument, url, inputs) => {
  const form = parentDocument.createElement('form')

  form.setAttribute('method', 'POST')
  form.setAttribute('action', url)

  for (const { name, value } of inputs) {
    const valueString = typeof value !== 'string' ? JSON.stringify(value) : value
    form.appendChild(createFormField(name, valueString))
  }

  return form
}

const submitForm = (doc, form) => {
  doc.body.appendChild(form)
  form.submit()
  doc.body.removeChild(form)
}

const createFormField = (name, value) => {
  const field = document.createElement('input')
  field.setAttribute('type', 'hidden')
  field.setAttribute('name', name)
  field.setAttribute('value', value)

  return field
}

export {
  postDataToPage,
}
